import { FC, useState } from 'react';
import { IFeatureForm } from '@pro/feature/interface';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import Message from '@base/lib/Message';
import { Form } from 'antd';
import { Button } from '@base/lib/Button';
import JsonForm from '@base/lib/JsonForm';
import { IFeatureProps } from 'mod/featureV2/interface';
import api from 'base/utils/api';

export const FeatureForm: FC<IFeatureProps<IFeatureForm>> = props => {
    const {
        feature: {
            config: {
                apiUrl,
                formItems,
                initialValues,
                buttonProps,
            }
        }
    } = props;

    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async (data) => {
        setLoading(true);
        try {
            await api.post(apiUrl, { data })
            form.resetFields();
            // 触发回调事件
            const eventName = props.feature?.config?.submitEvent || 'FEATURE_FORM_SUBMIT_SUCCESS';
            window.dispatchEvent(new CustomEvent(eventName, {
                detail: data
            }));
        } catch (e) {
            Message.error(e.message);
        }
        setLoading(false);
    };

    return (
        <FeatureContainer {...props}>
            <div className="g-wrapper">
                <JsonForm
                    className={'g-form'}
                    form={form}
                    formProps={{
                        layout: 'vertical',
                        onFinish: handleSubmit
                    }}
                    config={formItems}
                    initialValues={initialValues}
                    extra={
                        <div className="text-center g-btns">
                            <Button
                                htmlType={"submit"}
                                loading={loading}
                                {...buttonProps}
                            />
                        </div>
                    }
                />
            </div>
        </FeatureContainer>
    )
};
